// WCAG 2.x contrast. Accepts #rgb or #rrggbb; anything else yields undefined.
var WCAG_AA_NORMAL_TEXT = 4.5;
var parseHex = function (hex) {
    var match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
    if (!match) {
        return undefined;
    }
    var digits = match[1].length === 3
        ? match[1]
            .split('')
            .map(function (d) { return d + d; })
            .join('')
        : match[1];
    return [0, 2, 4].map(function (i) { return parseInt(digits.slice(i, i + 2), 16); });
};
var relativeLuminance = function (_a) {
    var r = _a[0], g = _a[1], b = _a[2];
    var _b = [r, g, b].map(function (channel) {
        var c = channel / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    }), lr = _b[0], lg = _b[1], lb = _b[2];
    return 0.2126 * lr + 0.7152 * lg + 0.0722 * lb;
};
var contrastRatio = function (foreground, background) {
    var fg = parseHex(foreground);
    var bg = parseHex(background);
    if (!fg || !bg) {
        return undefined;
    }
    var _a = [relativeLuminance(fg), relativeLuminance(bg)].sort(function (a, b) { return b - a; }), light = _a[0], dark = _a[1];
    return (light + 0.05) / (dark + 0.05);
};
export var ColorUtils = {
    WCAG_AA_NORMAL_TEXT: WCAG_AA_NORMAL_TEXT,
    contrastRatio: contrastRatio,
};
